module.exports = __webpack_public_path__ + "img/stock7.d1db12f5.png";